import { appSettings } from '@/settings/app-settings';

import createHttpClient from './http-client';

const httpClient = createHttpClient(appSettings.api.ASSET_MANAGER_URL || '');

export async function createShareLink(payload: any) {
  try {
    const response = await httpClient.post('/share-link/generate', payload);
    return response.data;
  } catch (error: any) {
    console.log('>>> error creating share link', error.message);
    throw error;
  }
}

// export async function fetchShareLink(linkId: any, metaDataOnly = false) {
//   try {
//     const response = await httpClient.get(`/share-link/use?linkId=${linkId}&metadataOnly=${metaDataOnly}`);
//     return response.data;
//   } catch (error: any) {
//     console.log('>>> error fetching share link', error.message);
//     throw error;
//   }
// }

export async function fetchShareLinkMetadata(linkId: any) {
  try {
    const response = await httpClient.get(`/share-link/metadata/${linkId}`);
    return response.data;
  } catch (error: any) {
    console.log('>>> error fetching share link', error);
    throw error;
  }
}

export async function useShareLink(linkId: any) {
  try {
    const response = await httpClient.get(`/share-link/usage/${linkId}`);
    return response.data;
  } catch (error: any) {
    console.log('>>> error fetching share link', error.message);
    throw error;
  }
}

export async function getShareLinkCreator(linkId: any) {
  try {
    const response = await httpClient.get(`/share-link/link-creator/${linkId}`);
    return response.data;
  } catch (error: any) {
    console.log('>>> error fetching share link creator details', error.message);
    throw error;
  }
}
